import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core'
import {
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import { filter, switchMap, take } from 'rxjs/operators'
import { of, Observable } from 'rxjs'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { QuoteStatus } from '../../../../models/status/status.model'
import moment from 'moment'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { SnackbarService } from '../../../../shared/directive/snackBar/snackbar.service'
import { CommonService } from '../../../../shared/services/common.service'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { Discounts } from '../../../../models/discounts.model'
import { QuoteCartFacade } from '../../../cart/mini-cart/store/mini-quote-cart.facade'

import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../shared/services/gtm.service';

// export enum Discounts {
//   ZRGD = 'Region Discount',
//   ZCUD = 'Customer Discount',
//   ZQSD = 'Product/Volume Discount',
//   ZLVD = 'Product/Volume Discount',
//   ZHVD = 'Product/Volume Discount',
//   ZSQD = 'Stock Order Discount',
//   ZSVD = 'Stock Order Discount',
//   ZSD1 = 'Manual Discount Adjustment',
//   ZSD2 = 'Manual Discount Adjustment',
//   ZDSH = 'Manual Adder Adjustment',
//   ZEDC = 'Express Delivery Adder',
//   ZDOA = 'Coupon',
// }

export interface Item {
  quantity?: any
  productType?: string
  product?: any
  entryNumber?: any
  totalPrice?: any
  selectedLegalEntity?: any
}

@Component({
  standalone: false,

  selector: 'vs-quote-cart-product',
  templateUrl: './quote-cart-product.component.html',
  styleUrls: ['./quote-cart-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteCartProductComponent implements OnInit, OnChanges {
  @Input() reviewFlag: any
  @Input() customerRequestedDate: Date
  @Input() productOpen
  @Input() product: any
  @Output() refreshList = new EventEmitter<string>()
  @Output() refreshQtyList = new EventEmitter<string>()
  @Output() deleteProductFromList = new EventEmitter<any>()
  @Output() deleteLoading = new EventEmitter<any>()
  @Input() brands
  @Input() entryNum = 0
  @Input() checkAll: boolean
  @Output()
  selectedEntry: EventEmitter<any> = new EventEmitter()
  cartNumber = 0
  cartStatus: string
  minDate = new Date()
  cartId: string
  userType: string
  public commentOpen = false
  // product: any;
  user$: Observable<User>
  breakUp = false
  loading = false
  OpenPopUp = false
  isEdit = false
  disableToggle: boolean
  quantity = new FormControl('', [Validators.required])
  date = new Date()
  brand = new FormControl('', [Validators.required])
  isLoggedInUser = false
  editProduct: any = {}
  updatedPartNum = ''
  updatedPartName = ''
  updatedSerialNum = ''
  updatedTagNum = ''
  updatedReasonForQuote = ''
  updatedPartType = ''
  updatedCsrReview = ''
  updatedUnsolicited = ''
  productType: string
  QuoteStatus = QuoteStatus
  // public reasonForQuoteArray$: Observable<any>;
  @Input() reasonForQuotes
  equipment: boolean = false
  @Input() reasonForQuote
  @Input() cartProductsList: any
  showCheckAvalabilityAction = false
  savingComments = false
  commentError = false
  availableAt
  selectedLeadTime
  showNotAvailableMsg: boolean
  commentsSaved = false
  showCommentsNotSavedErr = false
  savingMaterialNum: boolean = false
  defaultPlant = {
    code: 0,
    name: 'Select',
    stockAvailable: 'Not Available',
  }
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  shippedFrmOptions: any[] = []
  otherInventoryLocations: any[] = []
  serialNumFlag: boolean
  @Output()
  selectedLegalEntityId: EventEmitter<any> = new EventEmitter()
  
  leadTimeOptions: any[] = [
    { "sap_code": "30", "delivery_time": "1 Day ARO" },
    { "sap_code": "33", "delivery_time": "2 Days ARO" },
    { "sap_code": "36", "delivery_time": "3 Days ARO" },
    { "sap_code": "39", "delivery_time": "4 Days ARO" },
    { "sap_code": "42", "delivery_time": "5 Days ARO" },
    { "sap_code": "48", "delivery_time": "1 Week ARO" },
    { "sap_code": "51", "delivery_time": "2 Weeks ARO" },
    { "sap_code": "54", "delivery_time": "3 Weeks ARO" },
    { "sap_code": "57", "delivery_time": "4 Weeks ARO" },
    { "sap_code": "63", "delivery_time": "5 weeks" },
    { "sap_code": "64", "delivery_time": "6 weeks" },
    { "sap_code": "65", "delivery_time": "7 weeks" },
    { "sap_code": "66", "delivery_time": "8 weeks" },
    { "sap_code": "67", "delivery_time": "9 weeks" },
    { "sap_code": "68", "delivery_time": "10 weeks" },
    { "sap_code": "96", "delivery_time": "11 weeks" },
    { "sap_code": "69", "delivery_time": "12 weeks" },
    { "sap_code": "97", "delivery_time": "13 weeks" },
    { "sap_code": "70", "delivery_time": "14 weeks" },
    { "sap_code": "98", "delivery_time": "15 weeks" },
    { "sap_code": "71", "delivery_time": "16 weeks" },
    { "sap_code": "72", "delivery_time": "18 weeks" },
    { "sap_code": "73", "delivery_time": "20 weeks" },
    { "sap_code": "74", "delivery_time": "22 weeks" },
    { "sap_code": "75", "delivery_time": "24 weeks" }
  ]

  constructor(
    private formBuilder: FormBuilder,
    private quoteService: QuoteCartService,
    private auth: AuthService,
    public snackbar: SnackbarService,
    private launchDialogService: LaunchDialogService,
    private globalMessageService: GlobalMessageService,
    private cRef: ChangeDetectorRef,
    private router: Router,
    public commonService: CommonService,
    private calenderConfigService: CalenderConfigService,
    private userAccountFacade: UserAccountFacade,
    private multiCartService: MultiCartFacade,
    private activeCartService: ActiveCartFacade,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade
  ) {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          this.isLoggedInUser = true
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
          this.cartId = sessionStorage.getItem('cartId-current')
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'

          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
          this.cartId = sessionStorage.getItem('cartId-anonymous')
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.userType = 'current'
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
          this.cartId = sessionStorage.getItem('cartId-current')
        } else {
          this.userType = 'anonymous'
          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
          this.cartId = sessionStorage.getItem('cartId-anonymous')
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit(): void {
    this.cartNumber = this.entryNum++
    this.productType = this.product.productType
    this.brand.setValue(this.product.productLine)
    this.productOpen = true
    this.isEdit = false
    this.quantity.setValue(this.product.quantity)
    this.onQtyChanges()
    let count = 0
    if (this.product?.plantAvailableAt?.length) {
      this.product?.plantAvailableAt?.forEach((element) => {
        if (
          element?.defaultPlant === true &&
          (element.code == this.product?.selectedLegalEntity?.uid ||
            element.code.slice(0, 3) ==
              this.product?.selectedLegalEntity?.uid.slice(0, 3))
        ) {
          count++
          this.defaultPlant = element
          this.selectedLegalEntityId = element.code
        }

        if (
          element.code == this.product?.selectedLegalEntity?.uid ||
          element.code.slice(0, 3) ==
            this.product?.selectedLegalEntity?.uid.slice(0, 3)
        ) {
          this.shippedFrmOptions.push(element)
        } else {
          this.selectedLegalEntityId = undefined
          this.otherInventoryLocations.push(element)
        }
      })
    }
    if (this.product?.plantAvailableAt?.length == 0)
      this.selectedLegalEntityId = undefined
    if (count === 1) {
      this.showNotAvailableMsg = false
      this.availableAt =
        this.defaultPlant?.name +
        '(' +
        (Number(this.defaultPlant?.stockAvailable) || 0) +
        ')'
    } else {
      this.showNotAvailableMsg = true
      this.availableAt =
        this.product?.selectedLegalEntity?.salesOrganization +
        '(' +
        'Not available' +
        ')'
    }
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.userType = 'current'
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
          this.cartId = sessionStorage.getItem('cartId-current')
        } else {
          this.userType = 'anonymous'
          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
          this.cartId = sessionStorage.getItem('cartId-anonymous')
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    if (this.product.comment) {
      this.commentOpen = true
    }
    this.editProduct = Object.assign({}, this.product)
    if (
      this.product.serialNumber != undefined &&
      !this.product.isCatalogItem &&
      this.product.brandName == undefined &&
      this.product.quoteCartEntryType == undefined
    ) {
      this.isEdit = true
      this.productOpen = true
      this.equipment = true
    }
  }
  
  ngOnChanges(changes) {
    this.equipment = false
    if (
      changes?.customerRequestedDate?.currentValue !==
        changes?.customerRequestedDate?.previousValue &&
      changes?.cartProductsList?.currentValue ===
        changes.cartProductsList?.previousValue
    ) {
      this.product.customerRequestedDate =
        changes?.customerRequestedDate?.currentValue
      this.cRef.detectChanges()
    }
  }

  materialInputChanges() {
    if (
      this.editProduct.customerMaterialNumber.length >= 3 &&
      this.editProduct.customerMaterialNumber.length <= 25
    ) {
      this.savingMaterialNum = true
      this.saveMaterialNumber(
        this.editProduct.entryNumber,
        this.editProduct.customerMaterialNumber
      )
    }
  }

  onSaveMaterialNumMouseDown(event) {
    if (event.which == 1) {
      event.preventDefault()
      this.materialInputChanges()
    }
  }

  saveMaterialNumber(entryNumber, material_number) {
    this.quoteService
      .updateMaterialNumber(
        this.userType,
        this.cartId,
        entryNumber,
        material_number
      )
      .subscribe(
        (res) => {
          this.savingMaterialNum = false;
          this.cRef.detectChanges()
        },
        (error) => {
          this.savingMaterialNum = false;
          this.cRef.detectChanges()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  checkEntry(event: any) {
    const checkValue = event.target.checked
    this.selectedEntry.emit({
      entryNumber: this.product.entryNumber,
      checked: checkValue,
    })
  }
  openDeletePopUp() {
    const componentdata = {
      product: this.product,
      userType: this.userType,
      cartId: this.cartId,
    }

    const deleteQuoteCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.DELETE_QUOTE_CART,
      undefined,
      undefined,
      componentdata
    )
    if (deleteQuoteCartDialog) {
      deleteQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.DELETE_QUOTE_CART
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'delete-quote-cart') {
            this.deleteProduct()
          }
        })
    }
  }
  deleteProduct() {
    this.deleteLoading.emit(true)
    this.OpenPopUp = false
    this.quoteService
      .deleteProduct(this.userType, this.cartId, this.product.entryNumber)
      .subscribe(
        (success) => {
          if (
            this.cartProductsList !== undefined &&
            this.cartProductsList.length > 1
          ) {
            this.globalMessageService.add(
              { key: 'quoteCart.itemsRemoved' },
              GlobalMessageType.MSG_TYPE_CONFIRMATION,
              5000
            )
          }
          // this.snackbar.open('Product(s) has been removed successfully');
          // this.refreshList.emit('updated');
          this.deleteLoading.emit(false)
          this.deleteProductFromList.emit(this.product.entryNumber)
          this.removeItemEvent();
          this.quoteCartFacade.loadCart();
        },
        (error) => {
          this.deleteLoading.emit(false)
          this.globalMessageService.add(
            { key: 'quoteCart.errorOccured' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  updateProduct() {
    this.editProduct.brandCode = this.editProduct.brandName;
    this.editProduct.rfqPartDescription = (this.editProduct.rfqPartDescription) ? this.editProduct.rfqPartDescription : this.editProduct.product.partDescription;
    this.product.quantity = (this.product.quantity <= 0) ? 1 : this.product.quantity;
    this.editProduct.quantity = (this.editProduct.quantity <= 0) ? 1 : this.editProduct.quantity;

    this.quoteService
      .updateProduct(
        this.userType,
        this.cartId,
        this.product.entryNumber,
        this.editProduct
      )
      .subscribe(
        (res) => {
          this.product = res['entry']
          this.editProduct = this.product
          this.savingComments = false
          this.refreshList.emit('updated')
          this.quoteCartFacade.loadCart();
          this.cRef.detectChanges()
        },
        (err) => {
          this.savingComments = false
          this.cRef.detectChanges()
        }
      )

    // dataservice.subscribe((value) => this.OnDataUpdate(value));
  }
  updateComments() {
    this.editProduct.brandCode = this.editProduct.brandName
    this.quoteService
      .additionalComments(
        this.userType,
        this.cartId,
        this.product.entryNumber,
        this.editProduct.comment
      )
      .subscribe(
        (res) => {
          this.savingComments = false
          this.cRef.detectChanges()
        },
        (err) => {
          this.savingComments = false
          this.cRef.detectChanges()
        }
      )
  }
  updateLineItem(res) {
    // this.isEdit = false;
    // this.product = res.entry;
    this.editProduct = Object.assign({}, this.product)
    if (this.isEdit === false) {
      this.cRef.detectChanges()
    }
  }
  doneEditProduct() {
    if (
      (this.editProduct.productType?.toLowerCase().includes('parts') ||
        this.editProduct.productType?.toLowerCase().includes('part')) &&
      !this.product.isCatalogItem
    ) {
      if (this.editProduct.serialNumber != '') {
        this.isEdit = !this.isEdit
        this.productOpen = true
        this.updateProduct()
      } else if (this.editProduct.serialNumber == '') {
        this.isEdit = true
      }
    } else {
      this.isEdit = !this.isEdit
      this.productOpen = true
      this.updateProduct()
    }
  }
  duplicateProduct() {
    this.quoteService
      .duplicateProduct(this.userType, this.cartId, this.product.entryNumber)
      .subscribe(
        (success) => {
          this.refreshList.emit('updated')
          this.quoteCartFacade.loadCart();
          this.cRef.detectChanges()
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'quoteCart.errorOccured' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  splitQuoteItem(){
    this.quoteService
      .splitItemEntry(this.userType, this.cartId, this.product.entryNumber)
      .subscribe(
        (res) => {
          this.refreshList.emit('updated')
          this.quoteCartFacade.loadCart();
          this.cRef.detectChanges()
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  increaseQuantity(value) {
    this.product.quantity = this.quantity.value
    this.editProduct.quantity = this.quantity.value
    // this.product.quantity = this.product.quantity + 1;

    this.updateProduct()
  }
  decreaseQuantity(value) {
    this.product.quantity = this.quantity.value
    // this.product.quantity = this.product.quantity - 1;
    this.updateProduct()
  }
  toggleComment() {
    this.commentOpen = !this.commentOpen
  }
  openViewBreakup() {
    this.breakUp = !this.breakUp
  }
  toggleProduct() {
    this.productOpen = !this.productOpen
  }
  edit() {
    this.isEdit = true
    this.productOpen = true
  }
  cancel() {
    this.isEdit = false
    this.productOpen = true
    this.editProduct = Object.assign({}, this.product)
  }
  getFormattedDate(d) {
    if (d !== undefined) {
      var newDate = d.split('/')
      var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]
      var selectedMonthName = months[parseInt(newDate[1]) - 1]

      return newDate[2] + ' ' + selectedMonthName + ' ' + newDate[0]
    }
  }
  dateChange(event) {
    var newData = event
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]
    let paramDate = newData.split('/')
    let newDate = moment(event).format('YYYY/MM/DD')
    this.product.customerRequestedDate = newDate
    this.editProduct.customerRequestedDate = newDate
    // this.showCheckAvalabilityAction = true;
    this.checkForAvailability()
    this.updateProduct()
  }
  convertToDateFormat(d: string) {
    const date = new Date(d)
    return date
  }
  closeMenu(event) {
    this.breakUp = false
  }
  onQtyChanges(): void {
    this.quantity.valueChanges.subscribe((val: any) => {
      if (!Number.isInteger(val)) {
        val = Math.floor(val)
      }
      this.editProduct.quantity = val
      this.product.quantity = val
      // this.showCheckAvalabilityAction = true;
      this.checkForAvailability()
      this.updateProduct()
      if (this.isEdit === false) {
        // this.refreshQtyList.emit('updated');
      }
      // this.snackbar.open('Quote Cart updated', 'Done');
    })
  }
  getDiscountName(code) {
    return Discounts[code]
  }
  getTotalDiscounts(discounts) {
    let totalDisc = 0
    let discVal = discounts[0]?.formattedValue.trim()
    for (const disc of discounts) {
      totalDisc += disc.value
    }
    return discVal[0] + totalDisc.toFixed(2)
  }

  checkSerialNoDisplayLogic(productType, editProduct) {
    if (
      editProduct.productType?.toLowerCase().includes('parts') ||
      editProduct.productType?.toLowerCase().includes('part')
    ) {
      if (this.product.isCatalogItem) this.serialNumFlag = false
      else if (!this.product.isCatalogItem) this.serialNumFlag = true

      return true
    }

    return false
  }

  onCommentsInputBlur(event) {
    if (!this.commentsSaved && this.editProduct.comment?.length >= 0) {
      this.showCommentsNotSavedErr = true
    }
  }

  onSaveCommentsMouseDown(event) {
    if (event.which == 1) {
      event.preventDefault()
      this.commentUpdated()
    }
  }

  commentUpdated() {
    if (!this.isEdit) {
      if (!this.editProduct.comment || this.editProduct.comment?.length <= 0) {
        this.commentError = true
        return
      } else {
        this.commentError = false
      }
      this.savingComments = true
      this.commentsSaved = true
      this.showCommentsNotSavedErr = false
      this.updateComments()
    }
  }

  getAvailableQuantity(qty) {
    for (const availDetail of this.product.availabilityDetail) {
      if (
        moment(availDetail.committedDate).format('DD-MM-YYYY') ==
        moment(this.product.customerRequestedDate).format('DD-MM-YYYY')
      ) {
        return Number(availDetail.committedQuantity)
      }
    }
    return Number(qty)
  }
  showAvailabilityLoader: boolean = false

  dateFormatChange(dateInput) {
    return dateInput.replace(/-/g, '/')
  }
  checkAvailability(product) {
    this.showAvailabilityLoader = true
    const availableObj = {
      quantity: this.product.quantity,
      selectedPlant: this.defaultPlant,
      customerRequestedDate: this.product?.customerRequestedDate,
    }

    let apiParams = ['products', 'productCode']
    let lastPart = `checkAvailability?`
    lastPart += `productCode=${encodeURIComponent(this.product.product.code)}`
    apiParams.push(lastPart)
    const apiUrl = this.commonService.constructUrl(apiParams)
    this.commonService.postData(apiUrl, availableObj).subscribe(
      (data) => {
        this.product.availabilityDetail = data
        this.showCheckAvalabilityAction = false
        this.showAvailabilityLoader = false
        this.cRef.detectChanges()
      },
      (error) => {
        this.showCheckAvalabilityAction = false
        this.showAvailabilityLoader = false
        this.cRef.detectChanges()
        this.globalMessageService.add(
          { key: 'quoteCart.unknownErrorOccured' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  onLegalEntitySelect(e) {
    this.defaultPlant = e
    this.showCheckAvalabilityAction = true
    this.selectedLegalEntityId = e.code
    this.checkForAvailability()
  }

  onLeadTimeChange(e) {
    this.editProduct.leadTime = this.product.leadTime;
    this.updateProduct();
  }

  checkForAvailability() {
    let count = 0
    this.product?.plantAvailableAt?.forEach((element) => {
      if (element?.code === this.defaultPlant?.code && !element.defaultPlant) {
        count++
      }
    })
    if (count === 1) {
      this.showCheckAvalabilityAction = true
      this.showNotAvailableMsg = false
    } else {
      this.showCheckAvalabilityAction = false
      this.showNotAvailableMsg = true
    }
  }
  viewInventory() {
    const componentdata = {
      product: this.otherInventoryLocations,
    }

    const inventoryAvailabilityDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.INVENTORY_AVAILABILITY,
      undefined,
      undefined,
      componentdata
    )
    if (inventoryAvailabilityDialog) {
      inventoryAvailabilityDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  removeItemEvent(){
    const removeFromCartDataLayer: GTMDataLayer = {
      event: GtmEvents.RemoveFromCart,
      ecommerce: {
        currency: this.product.netPrice?.currencyIso,
        value: this.product.totalPrice?.formattedValue,
        items: [
          {
            item_id: this.product.product.code,
            item_name: this.product.product.name,
            index: this.product.entryNumber,
            item_list_id: ItemListTypeEnum.Cart,
            item_list_name: ItemListTypeEnum.Cart,
            price: this.product.totalPrice?.formattedValue,
            quantity: this.product.quantity,
          },
        ],
      },
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(removeFromCartDataLayer);
    }
}
